<template>
  <NewCheckout
      v-if="order"
      :isEdit="true"
      :localData="order"
      @orderChanged="(e) => {console.log(e)}"
      @orderSold="(e) => {console.log(e)}"
  />
</template>

<script lang="ts" setup>
import NewCheckout from "@/views/sales/NewCheckout.vue";
import {onMounted, ref} from "vue";
import {Order} from "@/models/sales/Order";
import {useHTTP} from "@/plugins/http";
import {useRoute} from "vue-router";

const http = useHTTP();
const route = useRoute();
const order = ref<Order>();

onMounted(async () => {
  try {
    const res = await http.get<Order>(`${Order.ENDPOINT}/${route.params.id}`);
    order.value = Order.from(res);
    order.value.customer = order.value.invoice.customer
    order.value.customerID = order.value.invoice.customer?.id
    order.value.paymentType = order.value.invoice.paymentType

    // check for packs
    for (let i = 0; i < order.value?.orderItems.length; i++) {
      if (order.value?.orderItems[i].packInfo) {
        const found = order.value.orderItems[i].item.itemPacks.filter(ip => ip.id == order.value.orderItems[i].packInfo.itemPackID)
        if (found.length) {
          order.value.orderItems[i].packInfo.itemPack = found[0]
        }
      }
    }

    // check for custom prices
    for (let i = 0; i < order.value?.orderItems.length; i++) {
      if (order.value?.orderItems[i].customPriceInfo) {
        if (order.value?.orderItems[i].customPriceInfo.type == 'item') {
          order.value.orderItems[i].packInfo = null;
          const found = order.value?.orderItems[i].item.itemCustomPrices.filter(icp => icp.id == order.value?.orderItems[i].customPriceInfo.itemCustomPriceID)
          if (found?.length) {
            order.value.orderItems[i].customPriceInfo.itemCustomPrice = found[0]
          }
        }
      }
    }

    // check for discounts
    if (order.value.invoice.totalDiscountAmount) {
      order.value.discountByAmount = order.value?.invoice.totalDiscountAmount
    }

    // Pre-fill discount if navigated from the payment page
    if (route.query.discountType && route.query.discountValue) {
      order.value.discountType = route.query.discountType as 'amount' | 'percentage'
      if (route.query.discountType === 'percentage') {
        order.value.discountByPercentage = Number(route.query.discountValue)
      } else {
        order.value.discountByAmount = Number(route.query.discountValue)
      }
    }
  } catch (e) {
    console.log(e)
  }
})


</script>
